import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import {
  InfiniteScrollCustomEvent,
  IonAvatar,
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { VxErrorComponent } from '@libs/core/lib/error-view/error-view.component';
import { VxDynamicImageComponent } from '@libs/core/lib/shared/mtjr-image.component';

import { signalStore } from '@ngrx/signals';

import { withVendorsListByFilter } from '@libs/mtjr/shared/generated/entities/vendor/vendor-store-features';
import { TranslatePipe } from '@ngx-translate/core';

export const VendorsListStore = signalStore(withVendorsListByFilter());
@Component({
  selector: 'mac-vendors-list',
  templateUrl: './vendors-list.page.html',
  providers: [VendorsListStore],
  imports: [
    IonInfiniteScroll,
    IonSpinner,
    IonBackButton,
    IonButtons,
    IonToolbar,
    IonContent,
    IonHeader,
    RouterModule,
    VxErrorComponent,
    VxDynamicImageComponent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonTitle,
    IonText,
    TranslatePipe,
    IonAvatar,
  ],
})
export class VendorsListPage {
  store = inject(VendorsListStore);
  route = inject(ActivatedRoute);
  title = signal('Products');

  constructor() {
    this.route.queryParams.subscribe((params) => {
      const filter = params['filter'];
      this.store.vendorsListByFilterPage({ filter: filter });
      const title = params['title'];
      if (title) {
        this.title.set(title);
      }
    });
  }

  async onIonInfinite(event: InfiniteScrollCustomEvent) {
    await this.store.vendorsListByFilterFetchNextPage();
    await event?.target?.complete();
  }
}
